import { combineReducers } from 'redux';
import { i18nReducer } from './i18n.reducer';
import { connectRouter } from 'connected-react-router';
import { pagesReducer } from './pages.reducer';
import { templatesReducer } from './templates.reducer';
import { singlePageReducer } from './singlePage.reducer';
import { settingsReducer } from './settings.reducer';
import { searchReducer } from './search.reducer';

export default history =>
    combineReducers({
        router: connectRouter(history),
        i18n: i18nReducer,
        pages: pagesReducer,
        page: singlePageReducer,
        templates: templatesReducer,
        settings: settingsReducer,
        search: searchReducer
    });
